// Personal reading shelf.
//
// A Reading row links a user to a project they've started/finished. Adding
// the same project twice is idempotent (the server dedupes on
// (user_email, project_id)); ``updateProgress`` accepts a 0-100 percent.
import { apiClient } from './apiClient';

const JSON_HEADERS = { headers: { 'Content-Type': 'application/json' } };

export async function listReadings() {
  const { data } = await apiClient.get('/api/readings/');
  return data?.readings ?? [];
}

export async function addToShelf(projectId) {
  const { data } = await apiClient.post(
    '/api/readings/',
    { project_id: Number(projectId) },
    JSON_HEADERS,
  );
  return data;
}

export async function updateProgress(readingId, percent) {
  const pct = Math.max(0, Math.min(100, Number(percent) || 0));
  const { data } = await apiClient.patch(
    `/api/readings/${readingId}/`,
    { progress_percent: pct },
    JSON_HEADERS,
  );
  return data;
}

export async function removeFromShelf(readingId) {
  const { data } = await apiClient.delete(`/api/readings/${readingId}/`);
  return data;
}

/**
 * Engagement counters for a project — readers (shelf rows), ratings
 * count + average, and total comments across every chapter docname.
 * Powers the read-page stat strip.
 */
export async function getProjectStats(projectId) {
  const { data } = await apiClient.get(`/api/projects/${projectId}/stats/`);
  return {
    readers: Number(data?.readers ?? 0),
    ratings: Number(data?.ratings ?? 0),
    ratingsAverage: Number(data?.ratings_average ?? 0),
    comments: Number(data?.comments ?? 0),
  };
}
